import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, withDefaults } from 'vue';

interface Props {
    value?: number;
    combinedWidth?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsTotalWidth',
  props: {
    value: { default: 0 },
    combinedWidth: { default: 0 }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update', value: number): void;
}), expose: any, slots: any, attrs: any }) {





const { proxy } = getCurrentInstance()!;

function updateTotalWidth(value: number | undefined): void {
    if (value === undefined) return;
    emit('update', value);
}

return { __sfc: true,emit, proxy, updateTotalWidth }
}

})